<template>
    <div class="power-analysis-container">
        <!-- <me-collapes @collapesCb="collapesCb" :treeTitle="'采集点选择'">
            <div style="height: 750px">
                <div class="tree-wrap">
                    <me-tree
                        ref="myTree"
                        :treeData="data"
                        :treeLoading="treeLoading"
                        :treeToolBar="false"
                        :defaultProps="defaultProps"
                        :defaultExpandedKeys="defaultCheckKeys"
                        :defaultExpandAll="true"
                        :nodeKey="'target_unit_id'"
                        :title="'采集点选择'"
                        @handleTreeNodeClick="handleTreeNodeClick"
                    ></me-tree>
                </div>
            </div>
        </me-collapes>-->
        <div class="leader-tab power-tab right_container" style="width: 100%">
            <div class="search_cont">
                <el-form
                    :inline="true"
                    :model="searchForm"
                    class="leader-style-form leader-form-inner-tab-inline"
                >
                    <el-form-item label="时间" style="float: left">
                        <el-date-picker
                            v-model="time"
                            type="month"
                            :clearable="false"
                            placeholder="选择月"
                            value-format="yyyy-MM"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                        ></el-date-picker>
                        <el-button
                            size="small"
                            @click="forwardTimeClick"
                            style="margin-left: 10px"
                        >上一月</el-button>
                        <el-button size="small" :disabled="nextTimeDisabled" @click="nextTimeClick">
                            下一月
                            <!-- <i class="el-icon-caret-right"></i> -->
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="table_cont-wrap">
                <el-scrollbar style="height: 100%">
                    <div class="echart-wrap">
                        <v-chart
                            :auto-resize="true"
                            :options="areaChart"
                            ref="lineHBar"
                            theme="ovilia-green"
                            @click="clickAreaChart"
                        />
                    </div>
                    <div class="echart-wrap">
                        <div class="echart-wrap-item">
                            <div class="chart_title">{{chartDate}}月用电构成</div>
                            <v-chart
                                :auto-resize="true"
                                :options="monthPieChart"
                                ref="lineHBar"
                                theme="ovilia-green"
                                v-if="showMonth"
                            />
                            <div style="width: 100%; height: 100%;" v-else>
                                <div class="kongyuan"></div>
                            </div>
                        </div>
                        <div class="echart-wrap-item">
                            <div class="chart_title">上年同期用电构成</div>
                            <v-chart
                                :auto-resize="true"
                                :options="sameMonthPieChart"
                                ref="lineHBar"
                                theme="ovilia-green"
                                v-if="showSameMonth"
                            />
                            <div style="width: 100%; height: 100%;" v-else>
                                <div class="kongyuan"></div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="echart-wrap">
                        <v-chart
                            :auto-resize="true"
                            :options="lineChart"
                            ref="lineHBar"
                            theme="ovilia-green"
                        />
                    </div>-->
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
// import moment from "moment";
import dayjs from "dayjs";
import * as api from "@/http/api.js";
import { getTargetUnitTreeList } from "@/http/target-config";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import utils from "@/utils/util";
import colorUtils from "@/utils/utils";
import { departmentColor, sameAndCircle } from "@/utils/chart-color.js";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes
    },
    data() {
        return {
            time: "",
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            nextTimeDisabled: false,
            todayM: "",
            systemDate: {},
            data: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "target_unit_name"
            },
            checkStrictly: true,
            defaultCheckKeys: [],
            pointName: "",
            nodeKey: "point_id",
            tableData: [],
            width: "calc(100% - 370px)",
            yearAxis: [
                // "2020-2",
                // "2020-3",
                // "2020-4",
                // "2020-5",
                // "2020-6",
                // "2020-7",
                // "2020-8",
                // "2020-9",
                // "2020-10",
                // "2020-11",
                // "2020-12",
                // "2021-1",
            ],
            yearLegend: [
                // "办公楼配电室",
                // "机加配电室",
                // "装配配电室",
                // "瓷件库配电室",
                // "金工车间",
            ],
            yearSeries: [
                // {
                //     type: "line",
                //     name: this.yearLegend[0],
                //     stack: "总量",
                //     areaStyle: {},
                //     data: [],
                // },
            ],
            lineAxis: [],
            lineYxis: [],
            monthPieOuter: [
                // { value: 335, name: "隔离开关车间" },
                // { value: 445, name: "焊接车间" },
                // { value: 234, name: "红光路管理" },
                // { value: 135, name: "组合电器制造部" },
                // { value: 913, name: "断路器制造部" },
                // { value: 251, name: "金工车间" },
                // { value: 147, name: "电气测控制造部" },
                // { value: 102, name: "十二路管理" },
            ],
            monthPieInner: [
                // {
                //     value: 335,
                //     name: "隔离开关车间",
                //     selected: true,
                // },
                // { value: 679, name: "红光路" },
                // { value: 1548, name: "凤城十二路" },
            ],
            monthPieSOuter: [
                // { value: 335, name: "隔离开关车间" },
                // { value: 445, name: "焊接车间" },
                // { value: 234, name: "红光路管理" },
                // { value: 135, name: "组合电器制造部" },
                // { value: 913, name: "断路器制造部" },
                // { value: 251, name: "金工车间" },
                // { value: 147, name: "电气测控制造部" },
                // { value: 102, name: "十二路管理" },
            ],
            monthPieSInner: [
                // {
                //     value: 335,
                //     name: "隔离开关车间",
                //     selected: true,
                // },
                // { value: 679, name: "红光路" },
                // { value: 1548, name: "凤城十二路" },
            ],
            chartDate: "2021-1",
            showMonth: true,
            showSameMonth: true,
        };
    },
    created() {
        this.getSysDate("day");
        this.todayM = this.getTimeValue("month");
        this.nextTimeDisabled = true;
        // for (let i = 0; i < this.yearLegend.length; i++) {
        //     this.yearSeries.push({
        //         type: "line",
        //         name: this.yearLegend[i],
        //         stack: "总量",
        //         areaStyle: {
        //             opacity: 0.2,
        //         },
        //         data: utils.getSeriesData(0, 100, 12),
        //     });
        // }
        // let dayNum = utils.mGetDate(2021, 1);
        // this.lineAxis = this.getAxis(dayNum, "2021-1");
        // this.lineYxis = [
        //     utils.getSeriesData(0, 200, dayNum),
        //     utils.getSeriesData(0, 200, dayNum),
        // ];
    },
    methods: {
        getTargetPriceSumList() {
            api.getTargetPriceSumList({
                show_day: dayjs(new Date(this.time)).format("YYYY-MM")
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.yearLegend = [];
                    this.yearAxis = res.bus_json.year_month_list;
                    this.yearSeries = [];
                    if (res.bus_json.list && res.bus_json.list.length) {
                        res.bus_json.list.forEach(item => {
                            this.yearLegend.push(item.name);
                            this.yearSeries.push({
                                type: "line",
                                name: item.name,
                                stack: "总量",
                                smooth: true,
                                symbol: "none",
                                areaStyle: {
                                    opacity: 0.2
                                },
                                data: item.target_amount_list
                            });
                        });
                    }
                    this.clickAreaChart({
                        name: dayjs(new Date(this.time)).format("YYYY-MM")
                    });
                }
            });
        },
        getAxis(num, str) {
            let xAxis = [];
            for (let i = 1; i <= num; i++) {
                if (str.length) {
                    xAxis.push(str + "-" + i);
                } else {
                    xAxis.push(i);
                }
            }
            return xAxis;
        },
        clickAreaChart(chartParam) {
            this.chartDate = chartParam.name;
            // let dateArr = chartParam.name.split("-");
            // let dayNum = utils.mGetDate(dateArr[0] * 1, dateArr[1] * 1);
            // this.lineAxis = this.getAxis(dayNum, chartParam.name);
            // this.lineYxis = [
            //     utils.getSeriesData(0, 200, dayNum),
            //     utils.getSeriesData(0, 200, dayNum),
            // ];
            // let num = utils.getSeriesData(0, 400, 1);
            // this.monthPieOuter[0].value = num;
            // this.monthPieInner[0].value = num;
            // this.monthPieSOuter[0].value = num;
            // this.monthPieSInner[0].value = num;
            //当月数据
            this.monthPieInner = [];
            this.monthPieOuter = [];
            this.showMonth = true;
            api.getTargetPriceList({ show_day: this.chartDate }).then(res => {
                if (res && res.error_code === "0") {
                    if (res.bus_json.p_list && res.bus_json.p_list.length) {
                        res.bus_json.p_list.forEach((item, index) => {
                            this.monthPieInner.push({
                                value: item.target_amount,
                                name: item.target_unit_name,
                               // selected: index == 0
                            });
                        });
                        this.showMonth = res.bus_json.p_list.some(f => parseFloat(f.target_amount) > 0);
                    }
                    if (res.bus_json.list && res.bus_json.list.length) {
                        res.bus_json.list.forEach((item, index) => {
                            this.monthPieOuter.push({
                                value: item.target_amount,
                                name: item.target_unit_name,
                            //    selected: index == 0
                            });
                        });
                    }
                }
            });
            //去年同期
            this.monthPieSInner = [];
            this.monthPieSOuter = [];
            this.showSameMonth = true;
            api.getTargetPriceList({
                show_day: dayjs(this.chartDate)
                    .subtract(1, "year")
                    .format("YYYY-MM")
            }).then(res => {
                if (res && res.error_code === "0") {
                    if (res.bus_json.p_list && res.bus_json.p_list.length) {
                        res.bus_json.p_list.forEach((item, index) => {
                            this.monthPieSInner.push({
                                value: item.target_amount,
                                name: item.target_unit_name,
                               // selected: index == 0
                            });
                        });
                        this.showSameMonth = res.bus_json.p_list.some(f => parseFloat(f.target_amount) > 0);
                    }
                    if (res.bus_json.list && res.bus_json.list.length) {
                        res.bus_json.list.forEach((item, index) => {
                            this.monthPieSOuter.push({
                                value: item.target_amount,
                                name: item.target_unit_name,
                              //  selected: index == 0
                            });
                        });
                    }
                }
            });
        },
        /**
         * 获取系统时间
         */
        getSysDate(type) {
            api.getSysDate1().then(res => {
                if (res && res.error_code === "0") {
                    this.systemDate = res.bus_json;
                    this.time = res.bus_json.sysdate;
                    // this.getTargetUnitTreeList();
                    this.getTargetPriceSumList();
                }
            });
        },
        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.state === "1") {
                    //实采集点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else if (obj.state === "0") {
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        handleTreeNodeClick(select) {
            if (select.state == "1") {
                this.$message({
                    message: "当前节点没有公式",
                    type: "warning"
                });
            } else {
                this.defaultCheckKeys = [
                    this.$refs.myTree.$refs.tree.getCurrentKey()
                ];
                this.pointName = select.tree_unit_name;
            }
        },
        /**
         * 获取采集点信息
         */
        getTargetUnitTreeList() {
            this.treeLoading = true;
            getTargetUnitTreeList().then(res => {
                if (res && res.error_code === "0") {
                    this.data = res.bus_json;
                    this.defaultCheckKeys = [res.bus_json[0].point_id];
                    this.pointName = res.bus_json[0].tree_unit_name;
                    this.$nextTick(() => {
                        this.$refs.myTree.$refs.tree.setCurrentKey(
                            res.bus_json[0].point_id
                        );
                    });
                }
                this.treeLoading = false;
            });
        },
        /**
         * 日期改变回调函数
         */
        handleTimeChange(val) {
            let toDay = new Date(this.todayD).getTime();
            let selectTime = new Date(val).getTime();
            if (selectTime >= toDay) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
            this.getTargetPriceSumList();
        },
        /**
         * 获取时间值
         * params{type<string>} type = day(日) type = month(月) type = year(年)
         */
        getTimeValue(type) {
            let date = new Date();
            if (type === "year") {
                return date.getFullYear() + "";
            } else if (type === "month") {
                return date.getFullYear() + "-" + (date.getMonth() + 1);
            } else {
                return (
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1) +
                    "-" +
                    date.getDate()
                );
            }
        },
        /**
         * 下一日、下一月、下一年点击
         */

        nextTimeClick() {
            let todayM = new Date(this.todayM).getTime();
            this.time = dayjs(new Date(this.time))
                .add(1, "months")
                .format("YYYY-MM");
            // 获取报告列表
            // this.handleSearchReport();
            let selectTime = new Date(this.time).getTime();
            if (selectTime >= todayM) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
            this.getTargetPriceSumList();
        },
        /**
         * 上一日、上一月、上一年点击
         */
        forwardTimeClick() {
            this.nextTimeDisabled = false;
            this.time = dayjs(new Date(this.time))
                .subtract(1, "months")
                .format("YYYY-MM");
            this.getTargetPriceSumList();
            // 获取报告列表
            // this.handleSearchReport();
        },
        /**
         * 获取日报列表
         */
        getDayData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys[0];
            params = {
                point_id: point_ids,
                show_day: this.time
            };
            this.tableLoading = true;
            api.getDayDataForReport(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxis = [];
                    this.yAxis = [];
                    if (res.bus_json.length) {
                        res.bus_json.forEach(item => {
                            item.name = this.pointName;
                            this.xAxis.push(item.show_day);
                            this.yAxis.push(item.active_power);
                        });
                    }
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
            this.tableHLoading = true;
            api.getDayDataCollection(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xHAxis = [];
                    this.yHAxis = [];
                    if (res.bus_json.length) {
                        res.bus_json.forEach(item => {
                            item.name = this.pointName;
                            this.xHAxis.push(item.show_day);
                            this.yHAxis.push(item.active_power);
                        });
                    }
                    this.tableHData = res.bus_json;
                }
                this.tableHLoading = false;
            });
        },
        /**
         * 选择搜索
         */
        handleSearchReport() {
            // this.getDayData();
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 370px)" : "calc(100% - 56px)";
        }
    },
    computed: {
        areaChart() {
            const options = {
                color: departmentColor,
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985"
                        }
                    }
                },
                legend: {
                    data: this.yearLegend,
                    textStyle: {
                        color: colorUtils.getFontColor()
                    }
                },
                grid: {
                    left: "5%",
                    right: "5%",
                    top: "10%",
                    bottom: "10%",
                    containLabel: true
                },
                xAxis: [
                    {
                        name: "月",
                        type: "category",
                        boundaryGap: false,
                        axisLine: {
                            lineStyle: {
                                color: "#999999"
                            }
                        },
                        data: this.yearAxis
                    }
                ],
                yAxis: [
                    {
                        name: "kW·h",
                        type: "value",
                        axisLine: {
                            lineStyle: {
                                color: "#999999"
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: "solid",
                                color: ["#999999"]
                            }
                        }
                    }
                ],
                series: this.yearSeries
            };
            return options;
        },
        monthPieChart() {
            // legend: {
            //         top: "10%",
            //         left: "center",
            //         textStyle: {
            //             color: "#fff",
            //         },
            //     },
            const options = {
                color: departmentColor,
                // title: {
                //     text: this.chartDate + "月用电构成",
                //     left: "center",
                //     textStyle: {
                //         color: colorUtils.getFontColor()
                //     }
                // },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                series: [
                    {
                        name: "用电构成",
                        type: "pie",
                        selectedMode: "single",
                        radius: [0, "70%"],
                        center: ["50%", "50%"],
                        top: 20,
                        label: {
                           // position: "inner"
                           fontSize: 15
                        },
                        // labelLine: {
                        //     show: false
                        // },
                        data: this.monthPieInner
                    },
                    // {
                    //     name: "用电构成",
                    //     type: "pie",
                    //     radius: ["40%", "55%"],
                    //     top: 20,
                    //     label: {
                    //         show: false
                    //     },
                    //     labelLine: {
                    //         show: false
                    //     },
                    //     label: {
                    //         formatter: "{b|{b}：}{c} {per|{d}%}",
                    //         // backgroundColor: '#0b1929',
                    //         // borderColor: '#aaa',
                    //         // borderWidth: 1,
                    //         // borderRadius: 4,
                    //         rich: {
                    //             a: {
                    //                 color: "#56fbff",
                    //                 lineHeight: utils.resizeSize(22),
                    //                 align: "center"
                    //             },
                    //             hr: {
                    //                 // borderColor: '#aaa',
                    //                 // width: '100%',
                    //                 // borderWidth: 0.5,
                    //                 height: 0
                    //             },
                    //             b: {
                    //                 fontSize: utils.resizeSize(16),
                    //                 lineHeight: utils.resizeSize(33)
                    //             },
                    //             per: {
                    //                 // color: '#eee',
                    //                 // backgroundColor: "#334455",
                    //                 // padding: [2, 4],
                    //                 // borderRadius: 2,
                    //             }
                    //         }
                    //     },
                    //     data: this.monthPieOuter
                    // }
                ]
            };
            return options;
        },
        sameMonthPieChart() {
            const options = {
                color: departmentColor,
                // title: {
                //     text: "上年同期用电构成",
                //     left: "center",
                //     textStyle: {
                //         color: "#fff"
                //     }
                // },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                series: [
                    {
                        name: "用电构成",
                        type: "pie",
                        selectedMode: "single",
                        radius: [0, "70%"],
                        center: ["50%", "50%"],
                        top: 20,
                        label: {
                          //  position: "inner"
                          fontSize: 15
                        },
                        // labelLine: {
                        //     show: false
                        // },
                        data: this.monthPieSInner
                    },
                    // {
                    //     name: "用电构成",
                    //     type: "pie",
                    //     radius: ["40%", "55%"],
                    //     top: 20,
                    //     // formatter:
                    //     //         "{a|{a}}{abg|}\n{hr|}\n {b|{b}：}{c} {per|{d}%}",
                    //     label: {
                    //         formatter: "{b|{b}：}{c} {per|{d}%}",
                    //         // backgroundColor: '#0b1929',
                    //         // borderColor: '#aaa',
                    //         // borderWidth: 1,
                    //         // borderRadius: 4,
                    //         rich: {
                    //             a: {
                    //                 color: "#56fbff",
                    //                 lineHeight: utils.resizeSize(22),
                    //                 align: "center"
                    //             },
                    //             hr: {
                    //                 // borderColor: '#aaa',
                    //                 // width: '100%',
                    //                 // borderWidth: 0.5,
                    //                 height: 0
                    //             },
                    //             b: {
                    //                 fontSize: utils.resizeSize(16),
                    //                 lineHeight: utils.resizeSize(33)
                    //             },
                    //             per: {
                    //                 // color: '#eee',
                    //                 // backgroundColor: '#334455',
                    //                 // padding: [2, 4],
                    //                 // borderRadius: 2,
                    //             }
                    //         }
                    //     },
                    //     data: this.monthPieSOuter
                    // }
                ]
            };
            return options;
        },
        lineChart() {
            const options = {
                color: sameAndCircle,
                title: {
                    text: this.chartDate + "月用电量趋势",
                    left: "center",
                    textStyle: {
                        color: "#fff"
                    }
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["用电量", "上年同期"],
                    textStyle: {
                        color: "#fff"
                    },
                    bottom: 10
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "20%",
                    containLabel: true
                },
                xAxis: {
                    name: "日",
                    type: "category",
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: "#999999"
                        }
                    },
                    data: this.lineAxis
                },
                yAxis: {
                    name: "kW·h",
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#999999"
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "solid",
                            color: ["#999999"]
                        }
                    }
                },
                series: [
                    {
                        name: "上年同期",
                        type: "line",
                        smooth: true,
                        symbol: "none",
                        stack: "总量",
                        data: this.lineYxis[1]
                    },
                    {
                        name: "用电量",
                        type: "line",
                        stack: "总量",
                        smooth: true,
                        symbol: "none",
                        data: this.lineYxis[0]
                    }
                ]
            };
            return options;
        }
    }
};
</script>
<style lang="scss">
@import "@/assets/css/date-picker";
.el-tabs__item {
    color: #fff;
}
.el-tabs--card {
    margin: 0;
}
.power-analysis-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    // .active-table {
    //     background: #ff7455 !important;
    //     color: #fff !important;
    //     border-color: #ff7455 !important;
    // }
    // .active-table-data {
    //     background: #083472 !important;
    //     color: #56fcff !important;
    //     border-color: #083472 !important;
    // }
    .tree-wrap {
        height: 100%;
        height: calc(100% - 10px);
        box-sizing: border-box;
    }
    .right_container {
        height: 100%;
        .el-tabs--card {
            margin: 0;
        }
        .search_cont {
            width: 100%;
            margin: 0 3rem 1rem 3rem;
            .form {
                display: flex;
                justify-content: space-between;
                .button-group {
                    display: inline-block;
                    margin-left: 20px;
                    .el-button.is-disabled,
                    .el-button.is-disabled:focus,
                    .el-button.is-disabled:hover {
                        border-color: #ebeef5;
                    }
                }
            }
        }
        .table_cont-wrap {
            width: 100%;
            height: calc(100% - #{px2Rem(80px)});
            padding: 0;
            box-sizing: border-box;
            overflow: hidden;
            position: relative;
            .is-horizontal {
                display: none;
            }
            .green {
                height: 12px;
                width: 5px;
                background: #0089f1;
                margin: 10px;
                float: left;
            }
            .table_change_btn {
                position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%, 0);
            }
            width: 100%;
            font-size: 16px;
            text-align: left;
            line-height: 32px;
            .echart-wrap {
                width: 100%;
                height: 20rem;
                display: inline-flex;
                justify-content: center;
                align-items: center;
                .echart-wrap-item {
                    width: 49%;
                    height: 100%;
                }
                .kongyuan {
                    height: 70%; width: 30%; border-radius: 70%; margin: 5% 0 0 35%; background-color: #ffff66;
                }
                .chart_title {
                    color: #fff;
                    text-align: center;
                    font-weight: 1000;
                    font-size: 18px;
                }
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
// .is-top .is-active {
//     color: #56fcff !important;
// }
.power-tab {
    margin: 4px 0 0 0;
}
</style>
